import React, { ReactNode } from "react"

interface HighlightTextProps {
  text: string | null
}

const HighlightText: React.FC<HighlightTextProps> = ({
  text,
}: {
  text: string | null
}) => {
  if (!text) return null
  const regex = /<b>(.*?)<\/b>/g
  const parts: Array<string | ReactNode> = []
  let lastIndex = 0

  let match
  while ((match = regex.exec(text)) !== null) {
    const start = match.index
    const end = regex.lastIndex
    const highlightedText = match[1]

    if (lastIndex < start) {
      parts.push(text.slice(lastIndex, start))
    }

    parts.push(
      <span
        key={end}
        className="font-normal text-amber-700 dark:text-sky-300"
      >
        {highlightedText}
      </span>
    )

    lastIndex = end
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return <>{parts}</>
}

export default HighlightText
